import React from "react";
import "./TpcTradeFloorExperience.css";

import warriorImage from "../../images/warrior1.webp";
import chartPrimary from "../../images/Chart 3.webp";
import chartSecondary from "../../images/Chart 5.webp";

const floorCards = [
  {
    eyebrow: "Theory Room",
    value: "01",
    title: "Frame the market",
    body: "Mentors map the session, key levels and risk before students move into execution.",
    trend: "gold",
  },
  {
    eyebrow: "Session Brief",
    value: "Plan",
    title: "Turn context into action",
    body: "Price action becomes a clear plan: what to watch, where to wait and when to stand aside.",
    trend: "green",
  },
  {
    eyebrow: "Next Step",
    value: "Floor",
    title: "Enter with structure",
    body: "Students step onto the trade floor with a defined plan instead of reacting to the screen.",
    trend: "red",
  },
];

const candleSequence = [
  "green",
  "green",
  "red",
  "green",
  "red",
  "green",
  "green",
  "red",
  "green",
  "red",
];

function TpcTradeFloorExperience({
  ctaHref = "https://andus.co.za/trade-register",
  ctaLabel = "Apply Now",
}) {
  return (
    <section
      id="tpc-trade-floor-experience"
      className="trpc-tradeFloor"
      aria-labelledby="trpc-tradeFloor-title"
    >
      <div className="trpc-tradeFloor__wrap">
        <div className="trpc-tradeFloor__shell">
          <div className="trpc-tradeFloor__media">
            <img
              className="trpc-tradeFloor__photo"
              src={warriorImage}
              alt="TPC trade floor mentor briefing students before a trading session"
              loading="eager"
              decoding="async"
              fetchPriority="high"
            />

            <img
              className="trpc-tradeFloor__chart trpc-tradeFloor__chart--one"
              src={chartPrimary}
              alt=""
              loading="lazy"
              decoding="async"
              aria-hidden="true"
            />

            <img
              className="trpc-tradeFloor__chart trpc-tradeFloor__chart--two"
              src={chartSecondary}
              alt=""
              loading="lazy"
              decoding="async"
              aria-hidden="true"
            />

            <div className="trpc-tradeFloor__marketRail" aria-hidden="true">
              {candleSequence.map((trend, index) => (
                <span
                  key={`${trend}-${index}`}
                  className="trpc-tradeFloor__candle"
                  data-trend={trend}
                />
              ))}
            </div>

            <div className="trpc-tradeFloor__imageGrid" aria-hidden="true" />
            <div className="trpc-tradeFloor__scanLine" aria-hidden="true" />
          </div>

          <div className="trpc-tradeFloor__route" aria-hidden="true">
            Theory room <span>→</span> Trade floor
          </div>

          <div className="trpc-tradeFloor__caption" aria-hidden="true">
            Mentor-led session brief
          </div>

          <div className="trpc-tradeFloor__content">
            <span className="trpc-tradeFloor__kicker">
              Trade floors · hosted sessions
            </span>

            <h2 id="trpc-tradeFloor-title" className="trpc-tradeFloor__title">
              Theory first. Floor next.
            </h2>

            <p className="trpc-tradeFloor__subtitle">
              Before students enter live market execution, mentors frame the
              session, the levels and the risk.
            </p>

            <a className="trpc-tradeFloor__btn" href={ctaHref} target="_blank" rel="noopener noreferrer">
              <span>{ctaLabel}</span>
              <span className="trpc-tradeFloor__btnIcon" aria-hidden="true">
                ↗
              </span>
            </a>
          </div>
        </div>

        <div
          className="trpc-tradeFloor__cardDeck"
          aria-label="Trade floor preparation path"
        >
          {floorCards.map((card) => (
            <article
              key={`${card.eyebrow}-${card.value}`}
              className="trpc-tradeFloor__card"
              data-trend={card.trend}
            >
              <span className="trpc-tradeFloor__cardRule" aria-hidden="true" />

              <p className="trpc-tradeFloor__cardEyebrow">{card.eyebrow}</p>

              <strong className="trpc-tradeFloor__cardValue">
                {card.value}
              </strong>

              <h3 className="trpc-tradeFloor__cardTitle">{card.title}</h3>

              <p className="trpc-tradeFloor__cardBody">{card.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TpcTradeFloorExperience;